import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../environments/environment';
import {tap} from 'rxjs/operators';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable({
  providedIn: 'root'
})

export class SharedService {

  httpOptions: object = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: ''
    })
  };

  s3BucketConfig = new S3(
    {
      accessKeyId: 'AKIA47N26QZ4FZMVBMMY____848484',
      secretAccessKey: 'U6CFOOnqDxN91/uZapp5OIvF2WsDoxjrgjLY0Hy59494894W',
      region: 'us-west-2'
    }
  );

  currentOrganisation = {name: 'All', _id: null};

  pageSettings: any = {};

  constructor(public httpClient: HttpClient, public cookieService: CookieService) {
  }

  getObjectsFromS3Bucket(fileParams: any) {
    return this.httpClient.post(environment.serverLink + '/getS3BucketObj', fileParams, this.generateHttpHeaders());
  }

  getUserDataFromSessionStorage() {
    let userInfo: any = sessionStorage.getItem('userInfo');
    userInfo = JSON.parse((userInfo === 'undefined') || (userInfo === '') ? null : userInfo);
    return userInfo;
  }

  generateHttpHeaders(responseType ?: any) {
    const authToken = this.cookieService.get('securityToken') ? 'Bearer ' + this.cookieService.get('securityToken') : '';
    return this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': responseType || 'application/json',
        Authorization: authToken
      })
    };
  }

  sendLocationToServer(data: any) {
    return;
    return this.httpClient.post(environment.serverLink + '/livelocationtracking/getLocation', data, this.generateHttpHeaders()).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  logOutCurrentSession() {
    return this.httpClient.get(environment.serverLink + '/logout', this.generateHttpHeaders()).pipe(tap(result => {
      this.currentOrganisation = {name: 'All', _id: null};
      return result;
    }, error => {
      return error;
    }));
  }

  logoutFromAllDevices() {
    return this.httpClient.get(environment.serverLink + '/logoutAll', this.generateHttpHeaders()).pipe(tap(result => {
      this.currentOrganisation = {name: 'All', _id: null};
      return result;
    }, error => {
      return error;
    }));
  }

  dataCreatedInfo() {
    const userAccess: any = {};
    const loggedInUserInfo = this.getUserDataFromSessionStorage();
    userAccess.canEdit = (loggedInUserInfo.level !== 1 && loggedInUserInfo.level !== 5);
    return userAccess;
  }

  userLevelDefinitions(level) {
    switch (+level) {
      case 0: {
        return 'Invalid User Level';
      }
      case 1: {
        // return 'SPI User';
        return 'L1';
      }
      case 2: {
        // return 'Organisation Head';
        return 'L2';
      }
      case 3: {
        // return 'Regional Head';
        return 'L3';
      }
      case 4: {
        // return 'State Head';
        return 'L4';
      }
      case 5: {
        // return 'Plant Incharge';
        return 'L5';
      }
    }
  }

  userStatusDefinitions(status) {
    switch (+status) {
      case 0: {
        return 'Added for Approval';
      }
      case 1: {
        return 'Approved';
      }
      case 2: {
        return 'Active';
      }
      case 3: {
        return 'Inactive';
      }
    }
  }
}
